import JSEncrypt from "jsencrypt";
import { post } from '../utils/http'
import api from "../utils/api";
import { sessionManager } from "../core/SessionManager";

export const doLogin = async (query) => {
    return;

}

export const forgetPwd = async (query) => {
    return;

}

export const resetPwd = async (query) => {
    return;

}

export const encrypt = (text, publicKey) => {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(publicKey);
    const encrypted = encrypt.encrypt(text);
    return encrypted;
}
